import { motion } from "framer-motion";
import "./FloatingDots.css";

const FloatingDots = () => {
  return (
    <div className="floating-dots-wrapper">
      {/* Yellow Floating Dot (up & down, left-top) */}
      <motion.div
        className="floating-dot-yellow floating-dot-yellow-1"
        animate={{ y: [0, -12, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Extra Green Floating Dot (top-left) */}
      <motion.div
        className="floating-dot-green floating-dot-green-2"
        animate={{ x: [0, -10, 0] }}
        transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
      />
    </div>
  );
};

export default FloatingDots;
